import type { Row } from '@tanstack/react-table';
import { Link } from '@ksyos/design-system';
import type { OrganizationDataError } from '@common/interfaces/api/organizationDataErrorsApi';

type OrganizationIdCellProps = {
    row: Row<OrganizationDataError>;
};

export default function OrganizationIdCell({ row }: Readonly<OrganizationIdCellProps>) {
    const organizationUrl = `/organizations/${row.original.organization.id}/view/details`;

    return (
        <Link
            onClick={(event) => event.stopPropagation()}
            rel="noreferrer"
            to={organizationUrl}
            variant="link"
        >
            {row.original.organization.txcsId}
        </Link>
    );
}
